var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/followingIconWhite.7743cd6d.png","uri@2x": __webpack_public_path__ + "static/media/followingIconWhite.7743cd6d.png","uri@3x": __webpack_public_path__ + "static/media/followingIconWhite.5c91b2ee.png",
    width: 32,
    height: 32
});